import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import EmailSent from "./pages/register/EmailSent";
import LinkInvalid from "./pages/register/LinkInvalid";
import Information from "./pages/register/Information";
import NotFoundPage from "./pages/NotFoundPage";
import ProtectedRoute from "./components/route/ProtectedRoute";
import SellerDashboard from "./pages/pageManageSeller/Dashboard";
import SellerRegisterInfo from "./pages/pageManageSeller/RegisterInfo";
import List from "./pages/pageManageSeller/List";
import SellerTransactionStatus from "./pages/pageManageSeller/TransactionStatus";
import PastListHistory from "./pages/pageManageSeller/PastListHistory";
import SellerTransactionHistory from "./pages/pageManageSeller/TransactionHistory";
import BuyerDashboard from "./pages/pageManageBuyer/Dashboard";
import BuyerRegisterInfo from "./pages/pageManageBuyer/RegisterInfo";
import BuyerTransactionStatus from "./pages/pageManageBuyer/TransactionStatus";
import BuyerTransactionHistory from "./pages/pageManageBuyer/TransactionHistory";
import CreateProduct from "./pages/pageManageSeller/product/CreateProduct";
import CheckListDetail from "./pages/pageManageSeller/product/CheckListDetail";
import SellerRegister from "./pages/register/SellerRegister";
import BuyerRegister from "./pages/register/BuyerRegister";
import EmailVerified from "./pages/register/EmailVerified";
import VerifyInformation from "./pages/register/VerifyInformation";
import AcceptTermService from "./pages/register/AcceptTermService";
import RegisterComplete from "./pages/register/RegisterComplete";
import SentEmailResetPassword from "./pages/auth/SentEmailResetPassword";
import ProductListBuyer from "./pages/pageManageBuyer/product/ProductList";
import ProductListSeller from "./pages/pageManageSeller/product/ProductList";
import ProductDetailBuyer from "./pages/pageManageBuyer/product/ProductDetail";
import ProductDetailSeller from "./pages/pageManageSeller/product/ProductDetail";
import TransactionDetailBuyer from "./pages/pageManageBuyer/transaction/TransactionDetail";
import TransactionDetailSeller from "./pages/pageManageSeller/transaction/TransactionDetail";
import LoginAdmin from "./pages/auth/admin/LoginAdmin";
import AdminDashboard from "./pages/pageManageAdmin/Dashboard";
import ReviewCompanyPage from "./pages/pageManageAdmin/CompanyReview";
import CompanyManagementPage from "./pages/pageManageAdmin/CompanyManagementPage";
import CompanyManagementViewPage from "./pages/pageManageAdmin/CompanyManagementViewPage";
import DetailReviewCompanyPage from "./pages/pageManageAdmin/DetailCompanyReview";
import ResetPassword from "./pages/auth/ResetPassword";
import ResetPasswordSuccess from "./pages/auth/ResetPasswordSuccess";
import ConversationInquiryBuyerPage from "./pages/pageManageBuyer/conversationInquiry/ConversationInquiryBuyerPage";
import ConversationInquiryPage from "./pages/pageManageSeller/conversationInquiry/ConversationInquiryPage";
import ConversationInquiryDetailPage from "./pages/pageManageSeller/conversationInquiry/ConversationInquiryDetail";
import TransactionHistory from "./pages/pageManageAdmin/TransactionHistory";
import InquiryList from "./pages/pageManageAdmin/InquiryList";
import ConversationInquiryDetailAdminPage from "./pages/pageManageAdmin/conversationInquiry/ConversationInquiryDetail";
import CompanyProductPage from "./pages/pageManageAdmin/CompanyProductsPage";
import CompanyTransactionListPage from "./pages/pageManageAdmin/CompanyTransactionListPage";
import CompanyRequestsPage from "./pages/pageManageAdmin/CompanyRequestsPage";
import ConversationInquiryAdminPage from "./pages/pageManageAdmin/conversationInquiry/ConversationInquiryAdminPage";
import CompanyManagementProductViewPage from "./pages/pageManageAdmin/CompanyManagementProductViewPage";
import CompanyManagementTransactionViewPage from "./pages/pageManageAdmin/CompanyManagementTransactionViewPage";
import CompanyManagementEditPage from "./pages/pageManageAdmin/CompanyManagementEditPage";
import EditProduct from "./pages/pageManageSeller/product/EditProduct";
import ConversationInquiryBuyerDetailPage from "./pages/pageManageBuyer/conversationInquiry/ConversationInquiryBuyerDetailPage";
import PastListInquirySeller from "./pages/pageManageSeller/conversationInquiry/PastListInquiry";
import PastListInquiryBuyer from "./pages/pageManageBuyer/conversationInquiry/PastListInquiry";
import ForgotPasswordAdminPage from "./pages/auth/admin/ForgotPasswordAdminPage";
import SentEmailResetPasswordAdminPage from "./pages/auth/admin/SentEmailResetPasswordAdminPage";
import ResetPasswordAdminPage from "./pages/auth/admin/ResetPasswordAdminPage";
import ResetPasswordSuccessAdminPage from "./pages/auth/admin/ResetPasswordSuccessAdminPage";
import CompanyManagementRequestViewPage from "./pages/pageManageAdmin/CompanyManagementRequestViewPage";
import PublicRoute from "./components/route/PublicRoute";
import GlobalRanking from "./pages/globalRanking/GlobalRanking";
import QuestManagementPage from "./pages/pageManageAdmin/QuestManagementPage";

const AppRoutes = () => {
  const publicRoutes = [
    // Registration
    { path: "/seller/register", component: SellerRegister },
    { path: "/seller/sent-mail", component: EmailSent },
    { path: "/buyer/register", component: BuyerRegister },
    { path: "/buyer/sent-mail", component: EmailSent },
    { path: "/verified", component: EmailVerified },
    { path: "/link-invalid", component: LinkInvalid },
    { path: "/information", component: Information },
    { path: "/verify-information", component: VerifyInformation },
    { path: "/accept-term-service", component: AcceptTermService },
    { path: "/register-complete", component: RegisterComplete },

    // Auth
    { path: "/", component: Login },
    { path: "/forgot-password", component: ForgotPassword },
    { path: "/reset-password", component: ResetPassword },
    { path: "/sent-mail-reset-password", component: SentEmailResetPassword },
    { path: "/reset-password-success", component: ResetPasswordSuccess },

    // Auth Admin
    { path: "/admin", component: LoginAdmin },
    { path: "/admin/forgot-password", component: ForgotPasswordAdminPage },
    {
      path: "/admin/sent-mail-reset-password",
      component: SentEmailResetPasswordAdminPage,
    },
    { path: "/admin/reset-password", component: ResetPasswordAdminPage },
    {
      path: "/admin/reset-password-success",
      component: ResetPasswordSuccessAdminPage,
    },
  ];

  const protectedRoutes = [
    // Seller
    { path: "/seller/dashboard", component: SellerDashboard },
    { path: "/seller/information", component: SellerRegisterInfo },
    { path: "/seller/list", component: List },
    { path: "/seller/transaction-status", component: SellerTransactionStatus },
    { path: "/seller/past-list-history", component: PastListHistory },
    {
      path: "/seller/transaction-history",
      component: SellerTransactionHistory,
    },
    { path: "/seller/product/create", component: CreateProduct },
    { path: "/seller/product/edit/:productCode", component: EditProduct },
    { path: "/seller/product/check-list-detail", component: CheckListDetail },
    { path: "/seller/product/list", component: ProductListSeller },
    { path: "/seller/product/:code", component: ProductDetailSeller },
    {
      path: "/seller/product/:code/transaction/:buyerId/:sellerId",
      component: TransactionDetailSeller,
    },
    {
      path: "/seller/conversation-inquiry/past-list",
      component: PastListInquirySeller,
    },
    {
      path: "/seller/conversation-inquiry",
      component: ConversationInquiryPage,
    },
    {
      path: "/seller/conversation-inquiry/:conversationInquiryId",
      component: ConversationInquiryDetailPage,
    },
    { path: "/seller/global-ranking", component: GlobalRanking },

    // Buyer
    { path: "/buyer/dashboard", component: BuyerDashboard },
    { path: "/buyer/information", component: BuyerRegisterInfo },
    { path: "/buyer/transaction-status", component: BuyerTransactionStatus },
    { path: "/buyer/transaction-history", component: BuyerTransactionHistory },
    { path: "/buyer/product/list", component: ProductListBuyer },
    { path: "/buyer/product/:code", component: ProductDetailBuyer },
    {
      path: "/buyer/product/:code/transaction/:buyerId/:sellerId",
      component: TransactionDetailBuyer,
    },
    {
      path: "/buyer/conversation-inquiry/past-list",
      component: PastListInquiryBuyer,
    },
    {
      path: "/buyer/conversation-inquiry",
      component: ConversationInquiryBuyerPage,
    },
    {
      path: "/buyer/conversation-inquiry/:conversationInquiryId",
      component: ConversationInquiryBuyerDetailPage,
    },
    { path: "/buyer/global-ranking", component: GlobalRanking },

    // Admin
    { path: "/admin/dashboard", component: AdminDashboard },
    { path: "/admin/review-company", component: ReviewCompanyPage },
    {
      path: "/admin/review-company/:companyCode",
      component: DetailReviewCompanyPage,
    },
    { path: "/admin/company-management", component: CompanyManagementPage },
    {
      path: "/admin/company-management/:companyCode/view",
      component: CompanyManagementViewPage,
    },
    {
      path: "/admin/company-management/:companyCode/edit",
      component: CompanyManagementEditPage,
    },
    {
      path: "/admin/company-management/:companyId/products",
      component: CompanyProductPage,
    },
    {
      path: "/admin/company-management/:companyId/product/:productCode/view",
      component: CompanyManagementProductViewPage,
    },
    {
      path: "/admin/company-management/:companyId/transactions",
      component: CompanyTransactionListPage,
    },
    {
      path: "/admin/company-management/:companyId/transaction/:transactionCode/view",
      component: CompanyManagementTransactionViewPage,
    },
    {
      path: "/admin/company-management/:companyId/requests",
      component: CompanyRequestsPage,
    },
    {
      path: "/admin/company-management/:companyCode/add-request",
      component: ConversationInquiryAdminPage,
    },
    {
      path: "/admin/company-management/:conversationInquiryId/view-request",
      component: CompanyManagementRequestViewPage,
    },
    { path: "/admin/transaction-history", component: TransactionHistory },
    { path: "/admin/global-ranking", component: GlobalRanking },
    { path: "/admin/quest-management", component: QuestManagementPage },
    { path: "/admin/conversation-inquiry", component: InquiryList },
    {
      path: "/admin/conversation-inquiry/:conversationInquiryId",
      component: ConversationInquiryDetailAdminPage,
    },
  ];

  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={
            <PublicRoute>
              <Component />
            </PublicRoute>
          }
        />
      ))}

      {/* Protected Routes */}
      {protectedRoutes.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute>
              <Component />
            </ProtectedRoute>
          }
        />
      ))}

      {/* 404 Page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
